const DriverApplicationStatus = {
    PENDING: "pending",
    APPROVED: "approved",
    REJECTED: "rejected",
}

export default DriverApplicationStatus 
